export default __webpack_public_path__ + "fr/static/media/help.069249b3.svg";